/**
 * 基础菜单 班级管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>班级列表</el-breadcrumb-item>
    </el-breadcrumb>


    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="queryParams" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="queryParams.className" placeholder="输入班级名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="queryParams.studentName" placeholder="输入学员姓名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()" v-if="xzFlag">添加</el-button>
      </el-form-item>
    </el-form>


    <!--列表-->
    <el-table size="small" :data="listData" :key="color_index" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60">
      </el-table-column>
      <el-table-column prop="className" label="班级名称" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <el-link type="primary" @click="openStudent(scope.row)">
            <span v-html="changeColor(scope.row.className)"></span>
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="subjectName" label="培训科目" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="studentNum" label="学生数" width="150">
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

  </div>
</template>

<script>
import { identificationRecognize, idCardIdentify } from '../../api/baidu'
import { identification, formatInportData, timestampToTime } from '../../utils/util'
import {
  queryByPage,
  savaClass,
  updateClass,
  deleteClass,
  queryClassDetail,
  generateQRCode, bindCourse, queryCourseByClassId, delCourseByClassId, getBzrList, getPzByShare, queryBzrBjByPage
} from '../../api/classInfo'
import Pagination from '../../components/Pagination'
import axios from "axios";
import Template from "../../components/template";
import {selectAreaTree} from "../../api/subjectTree";
import {getCourseMbList, getMarketingChannelList, getRoomList, queryCourseMbById} from "../../api/userMG";
import {getCourseList} from "../../api/course";
export default {
  data() {
    return {
      color_index: 0,
      add_index: 0,
      url: '/api/student/upload',
      fileList: [],
      loading: false, //是显示加载
      editFormShow: false, //控制编辑页面显示与隐藏
      title: '添加',
      form: {},
      queryParams: {
        page: 1,
        size: 10
      },
      listData: [], //用户数据
      access_token: '', // 百度文字识别 token
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

      openUpType: false,
      // 左侧树
      treeArr: [],  // 默认展示第二级树节点
      treeName: undefined,
      treeOptions: undefined,
      defaultProps: {
        children: "children",
        label: "label"
      },
      // 树状图 双击事件参数
      treeClickCnt: 0,
      treeClickTimeout: null,

      // 二维码弹窗控制
      shareShow: false,
      shareForm: {},

      marList: [],    // 营销渠道列表
      shareUrl: '',     // 二维码图片地址

      // 班级绑定课程
      templateId: '',

      toFlag: true,
      openBind: false,
      myCourseList: [],     // 所选课程
      templateList: [],     // 模版表
      classroomList: [],    // 教室
      bzrList: [],    // 班主任

      openCourse: false,
      courseList: [],       // 课程表下的课程

      xzFlag: true,
   }
  },
  watch: {
    // 根据名称筛选部门树
    treeName(val) {
      this.$refs.tree.filter(val);
    }
  },
  // 注册组件
  components: {
    Template,
    Pagination
  },
  /**
   * 创建完毕
   */
  created() {
    this.initData()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    timestampToTime,
    formatInportData,
    changeColor(name) {
      const newStr = name.replace(/“([^“”]*)”/g, '<span style="color: red;">$1</span>');
      console.log('newStr', newStr);
      return newStr;
    },
    indexMethod(index) {
      return (this.pageparm.currentPage - 1) * this.pageparm.pageSize + index + 1;
    },
    initData() {
      this.getdata()
      this.selectAreaTree()
      this.findClassroomList()

      var role = JSON.parse(localStorage.getItem('userdata'));
      console.log('role  ', role);
      role.roleList.forEach(x => {
        if (x.roleName == '班主任') {
          this.xzFlag = false;
        }
      })

      // 查询 班主任 下拉选
      getBzrList({page: 1, size: 9999}).then(res => {
        if (res.code == 200) {
          this.bzrList = res.data.content;
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      }).catch(err => {
        this.$message.error('加载失败，请稍后再试！')
      })
    },

    findClassroomList() {
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      getRoomList({page: 1, size: 99999}).then(res => {
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.classroomList = res.data.content
        }
      })
        .catch(err => {
          this.loading = false
          this.$message.error('加载失败，请稍后再试！')
        })
    },

    // 查询 科目树
    selectAreaTree() {
      selectAreaTree({}).then(res => {
        if (res.code == 200) {
          this.treeOptions = res.data;
          res.data.forEach(x => {
            this.treeArr.push(x.value)
          })

        }
      })
    },

    // 身份证文字识别
    idCardIdentify(idCardImg) {
      return new Promise((resolve, reject) => {
        var params = new FormData()
        params.append('image', idCardImg)//转Base64后的编码
        params.append('id_card_side', 'back')//身份证正反面参数，正：front，反：back
        params.append('access_token', this.access_token)
        axios.post(
          '/baiduOCR/rest/2.0/ocr/v1/idcard?', params,
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
        ).then((res) => {
          resolve(res.data.words_result)
        })
      })
    },
    handlePreview(event, file, fileList) {
      identification.transformBase64(file.raw).then(data => {//调用封装的base64转码方法
        console.log(`Base64---`, data)
        this.idCardIdentify(data).then(res => {//调用请求百度OCR身份证识别方法，将Base64传入
          console.log(`ocr识别----`, res)
        })
      })
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    // 成功回调
    handleFileSuccess(response, file, fileList) {
      console.log('response==', response);
      console.log('file==', file);
      console.log('fileList==', fileList);

      identification.transformBase64(file.raw).then(data => {//调用封装的base64转码方法
        console.log(`Base64---`, data)
        /*this.idCardIdentify(data).then(res => {//调用请求百度OCR身份证识别方法，将Base64传入
          console.log(`ocr识别----`, res)
        })*/
      })
    },
    identificationRecognize() {
      const data = { //这三个参数不能少
        grant_type: 'client_credentials',//固定参数
        client_id: '1gBK3e1NoRZQv89vaLmbXqfF',//你申请的AK
        client_secret: 'oqqSNa9Km2OjGO9AwbWNr29X0SfOGmr3'//你申请的SK
      }
      identificationRecognize(data).then(res => {
        console.log(`access_token---`, res)
        this.access_token = res.access_token;
      })
    },

    // 获取公司列表
    getdata() {
      // this.identificationRecognize();
      this.loading = true

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      queryBzrBjByPage(this.queryParams).then(res => {
          this.loading = false
          if (res.code != 200) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data.content
            // 分页赋值
            this.pageparm = res.data.pageparm
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.queryParams.page = parm.currentPage
      this.queryParams.size = parm.pageSize
      this.getdata()
    },

    openStudent(item) {
      var {href} = this.$router.resolve({
        path: "/goods/student",
        query: {
          classId: item.id,
          type: 1
        }
      })
      window.open(href, '_blank');
    },

    // 打开父级项目选择框
    openType() {
      this.openUpType = true
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 选择父级项目 节点点击事件
    handleNodeClick2(data) {
      // 如果点击的id不相同，则重置点击次数
      if (data.value != this.form.subjectId) {
        this.treeClickCnt = 0;
      }
      this.form.subjectId = data.value
      this.form.subjectName = data.label
      this.treeClickCnt++;

      // 注册清空点击次数计时器任务
      window.clearTimeout(this.treeClickTimeout);
      this.treeClickTimeout = window.setTimeout(() => {
        this.treeClickCnt = 0;
      }, 300);

      // 连续点击多次则不做任何事情
      if (this.treeClickCnt > 2) return;
      // 点击一次时单击事件
      if (this.treeClickCnt == 1) {
        // 单击事件
        console.log('单击');
      }
      // 点击两次时双击事件
      if (this.treeClickCnt == 2) {
        // 双击事件
        console.log('双击');
        this.submitUpType()
      }

    },
    // 保存父级项目
    submitUpType() {
      this.openUpType = false;
    },
    cancelUpType() {
      this.form.subjectId = undefined
      this.form.subjectName = undefined
      this.openUpType = false;
    },

    // 搜索事件
    search() {
      this.getdata()
    },

    handleCommand(item, command) {
      if(command == 1) {
        this.handleBind(1, item);
      } else if(command == 2) {
        this.handleEditCourse(1, item)
      } else if(command == 3) {
        this.handleDelCourse(1, item)
      } else if (command == 4) {
        this.handleEdit(1, item)
      } else if (command == 5) {
        this.sharePopup(1, item);
      }
    },

    // 显示 生成二维码 弹窗
    sharePopup(index, row) {
      this.form = JSON.parse(JSON.stringify(row));

      // 1：显示渠道，0：选择渠道
      getPzByShare().then(res => {
        if (res.data == 1) {
          this.shareShow = true;
        } else {
          generateQRCode({classId: this.form.id}).then(res => {
            if (res.code == 200) {
              this.shareUrl = "data:image/png; base64," + res.data;
              this.shareShow = true;
            }
          })
        }
      })
    },
    // 获取 二维码数据
    submitShare() {
      var params = {
        classId: this.form.id,
        marSeqId: this.shareForm.marSeqId
      }
      generateQRCode(params).then(res => {
        if (res.code == 200) {
          this.shareUrl = "data:image/png; base64," + res.data;
        }
      })
    },
    handleClose(done) {
      this.shareForm.marSeqId = '';
      this.shareUrl = '';
      done();
    },

    // 修改课程
    handleEditCourse(index, row) {
      this.form = JSON.parse(JSON.stringify(row));

      queryCourseByClassId(row.id).then(res => {
        if (res.code == 200) {
          this.myCourseList = res.data;

          getCourseList({page:1, size: 99999, subjectId: row.subjectId}).then(res => {
            if (res.code == 200) {
              if (res.data.content.length > 0) {
                var list = [];
                res.data.content.forEach(x => {
                  list.push({
                    kcmc: x.kcmc,
                    courseId: x.id,
                    roomId: '',
                    startTime: '',
                    endTime: '',
                    xs: x.xs,
                    dkfs: '',
                    ycdksj: '',
                    xsNum: 0
                  })
                })

                this.courseList = list;
                this.openBind = true;
              }
            }
          }).catch(err => {
            this.$message.error(err.response.data.msg)
          })
        }
      })
    },
    // 清空课程
    handleDelCourse(index, row) {
      this.$confirm('确定要删除绑定的课程吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delCourseByClassId(row.id).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getdata()
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
            .catch(err => {
              this.loading = false
              this.$message.error('删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },

    // 绑定 按钮操作
    handleBind(index, row) {
      this.form = JSON.parse(JSON.stringify(row));
      this.templateId = '';
      this.myCourseList = [];
      this.courseList = [];

      getCourseMbList({page: 1, size: 99999, subjectId: row.subjectId}).then(res => {
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.templateList = res.data.content;
          this.openBind = true;
        }
      })
        .catch(err => {
          this.loading = false
          this.$message.error('加载失败，请稍后再试！')
        })
    },

    // 获取课程表模版的课程
    changeTemplate(row) {
      // 切换模版，清空已选择的课程
      this.myCourseList = [];
      queryCourseMbById(row.id).then(res => {
        if (res.code == 200) {

          if (res.data.courseMbItemList.length > 0) {
            var list = [];
            res.data.courseMbItemList.forEach(x => {
              list.push({
                kcmc: x.kcmc,
                courseId: x.courseId,
                roomId: '',
                startTime: '',
                endTime: '',
                xs: x.xs,
                dkfs: '',
                ycdksj: '',
                xsNum: 0
              })
            })

            this.courseList = list;
          }
        }
      })
    },

    // 打开课程
    handleCourseData() {

      if (this.courseList.length > 0) {
        this.openCourse = true;

        if (this.myCourseList.length > 0) {
          var list = [];

          this.courseList.forEach(x => {
            this.myCourseList.forEach(y => {
              if (x.courseId == y.courseId) {
                list.push(x);
              }
            })
          });

          this.$nextTick(() => {
            list.forEach(x => {
              this.$refs.tableBox1.toggleRowSelection(x, true);
            })
          })

        } else {
          this.openCourse = true;
          this.$refs.tableBox1.clearSelection();
        }

      } else {
        this.$message.error('请先选择课程表模版');
      }
    },

    handleSelectionChange(selection) {
      console.log('selection  ', selection);

      var ids = [];
      if (this.myCourseList.length > 0) {
        ids = this.myCourseList.map(item => item.courseId);
        var list = [];
        selection.forEach(x => {
          if (ids.indexOf(x.courseId) == -1) {
            list.push(x)
          }
        })

        this.myCourseList = [...this.myCourseList, ...list];
      } else {
        this.myCourseList = JSON.parse(JSON.stringify(selection));
      }
    },

    // 删除绑定过的课程
    delBindCourse(index) {
      this.myCourseList.splice(index, 1)
      this.$refs.tableBox1.clearSelection();
    },

    submitCourse() {
      if (this.form.kcNum == 0) {
        if (!this.templateId) {
          this.$message.error('课程表模版不可为空');
          return;
        }
      }

      if (this.myCourseList.length == 0) {
        this.$message.error('请选择需要绑定的课程。');
      } else {

        for (let i = 0; i < this.myCourseList.length; i++) {
          var x = this.myCourseList[i];

          if (!x.startTime) {
            this.$message.error('开始时间不可为空');
            return;
          }
          if (!x.endTime) {
            this.$message.error('结束时间不可为空');
            return;
          }
          if (!x.xs) {
            this.$message.error('学时不可为空');
            return;
          }
          if (!x.roomId) {
            this.$message.error('教室不可为空');
            return;
          }
          if (!x.dkfs) {
            this.$message.error('签到方式不可为空');
            return;
          }
          if (!x.ycdksj) {
            this.$message.error('延长打卡时间不可为空');
            return;
          }
        }

        var params = {
          classId: this.form.id,
          lessonList: this.myCourseList
        }

        bindCourse(JSON.stringify(params)).then(res => {
          if (res.code == 200) {
            this.getdata();
            this.form = {}
            this.$message({
              type: 'success',
              message: '保存成功！'
            });
            this.openBind = false;
          } else {
            this.$message.error(res.msg);
          }
        })
      }

    },

    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormShow = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        queryClassDetail(row).then(res => {
          if (res.code == 200) {
            this.form = res.data;
          }
        })
      } else {
        this.title = '添加'
        this.form = {}
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if (this.form.id) {

            // 修改
            if (this.form.signUpEndTime) {
              this.form.signUpEndTime = timestampToTime(this.form.signUpEndTime)
            }
            if (this.form.studyStartTime) {
              this.form.studyStartTime = timestampToTime(this.form.studyStartTime)
            }
            if (this.form.studyStopTime) {
              this.form.studyStopTime = timestampToTime(this.form.studyStopTime)
            }
            updateClass(this.form).then(res => {
              this.editFormShow = false
              this.loading = false
              if (res.code == 200) {
                this.getdata()
                this.form = {}
                this.$message({
                  type: 'success',
                  message: '修改成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormShow = false
              this.loading = false
              this.$message.error('修改失败，请稍后再试！')
            })

          } else {

            // 新增
            if (this.form.signUpEndTime) {
              this.form.signUpEndTime = timestampToTime(this.form.signUpEndTime)
            }
            if (this.form.studyStartTime) {
              this.form.studyStartTime = timestampToTime(this.form.studyStartTime)
            }
            if (this.form.studyStopTime) {
              this.form.studyStopTime = timestampToTime(this.form.studyStopTime)
            }
            savaClass(this.form).then(res => {
              this.editFormShow = false
              this.loading = false
              if (res.code == 200) {
                this.getdata()
                this.form = {}
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormShow = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          }
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除该条数据吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteClass(row).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getdata()
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('删除失败，请稍后再试！')
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.form = {}
      this.editFormShow = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}

.tree-con {
  width: 250px;
  height: 95%;
  vertical-align: text-top;
  margin-top: 20px;
  display: inline-block;
  border: #544E4F 2px solid;
  border-radius: 8px;
}

</style>





// WEBPACK FOOTER //
// src/views/goods/classInfoByBzr.vue